module.exports = __webpack_public_path__ + "static/earthSpeakr_logo_white-7c67a4a846acd43b0d93d6ae051adba2.png";